import { toast } from "react-toastify";

import Driver from "../../../api/driver";

export const driver = {
  state: {
    loading: false,
    selectedDriver: "",
  },
  reducers: {
    setDriver(state, payload) {
      return { ...state, selectedDriver: payload };
    },
    loading(state, payload) {
      return {
        ...state,
        loading: payload.loading,
      };
    },
    clearStore() {
      return {};
    },
  },
  effects: (dispatch) => ({
    async getDriverByCNHAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const { data } = await Driver.getDriverByCNH(payload);
        this.loading({ loading: false });
        this.setDriver(data);
        return data;
      } catch (error) {
        this.loading({ loading: false });
        this.setDriver({ id: null });
        toast.error(error.response.data || "Erro ao buscar motorista!");
        return {
          success: false,
          message: error.response.data || "Erro ao buscar motorista!",
        };
      }
    },
    async getDriverByCNHAsyncNoState(payload, rootState) {
      try {
        this.loading({ loading: true });
        const { data } = await Driver.getDriverByCNH(payload);
        this.loading({ loading: false });        
        return data;
      } catch (error) {
        this.loading({ loading: false });        
        toast.error(error.response.data || "Erro ao buscar motorista!");
        return {
          success: false,
          message: error.response.data || "Erro ao buscar motorista!",
        };
      }
    },
  }),
};
